import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../../../store/reducers';
import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { hideDialog } from '../../../store/actions/prescriptionPad';
import { AnimatePresence } from 'framer-motion';
import { SlideFromRightWrapper } from '../SlideFromRightWrapper';
import Hotkeys from 'react-hot-keys';
import { Actions } from '../../../store/actions';
import { WithAppDiagnosis } from '../../WithAppDiagnosis';
import ResetToolBt from '../../../pages/profile/ResetToolBt';

type Props = {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
};

class TroubleshootMySystemDrawer extends PureComponent<Props> {
    closeMe = () => {
        const { dispatch } = this.props;
        dispatch(hideDialog('troubleshoot-my-system'));
    };

    render(): ReactNode {
        const { closeMe } = this;

        return (
            <AnimatePresence>
                <Hotkeys keyName="esc" onKeyDown={closeMe}>
                    <SlideFromRightWrapper closeMe={closeMe} cssClass="w-592">
                        <div
                            className="w-full h-full flex flex-col bg-darwin-neutrals-50 overflow-hidden"
                            style={{ color: '#1A1A1A' }}
                        >
                            <div className="px-16 py-12 flex items-center justify-between space-x-8 bg-white border-b border-darwin-neutral_new-200">
                                <div className="flex items-center space-x-8">
                                    <p className="text-20">Troubleshoot My System</p>
                                </div>
                                <button onClick={closeMe}>
                                    <svg
                                        className="w-14 h-14"
                                        viewBox="0 0 10 9"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8.88477 1.60352L5.83789 4.65039L8.85938 7.67188C9.11328 7.90039 9.11328 8.28125 8.85938 8.50977C8.63086 8.76367 8.25 8.76367 8.02148 8.50977L4.97461 5.48828L1.95312 8.50977C1.72461 8.76367 1.34375 8.76367 1.11523 8.50977C0.861328 8.28125 0.861328 7.90039 1.11523 7.64648L4.13672 4.625L1.11523 1.60352C0.861328 1.375 0.861328 0.994141 1.11523 0.740234C1.34375 0.511719 1.72461 0.511719 1.97852 0.740234L5 3.78711L8.02148 0.765625C8.25 0.511719 8.63086 0.511719 8.88477 0.765625C9.11328 0.994141 9.11328 1.375 8.88477 1.60352Z"
                                            fill="#1A1A1A"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className="flex-1 flex flex-col">
                                <p className="text-16 font-700 text-neutral-black p-24 pb-0">
                                    Troubleshoot status
                                </p>
                                <div className="py-16 px-24 space-y-16">
                                    <WithAppDiagnosis />
                                </div>

                                <div className="mx-24">
                                    <ResetToolBt
                                        className="bg-white font-700 border text-darwin-accent-bright-blue-800 border-darwin-accent-bright-blue-800 rounded-8 px-16 py-8"
                                        closeMe={closeMe}
                                    />
                                </div>
                            </div>
                        </div>
                    </SlideFromRightWrapper>
                </Hotkeys>
            </AnimatePresence>
        );
    }
}

export default connect()(TroubleshootMySystemDrawer);
